import { render } from "./AgentAdd.vue?vue&type=template&id=4664d9cc"
import script from "./AgentAdd.vue?vue&type=script&lang=js"
export * from "./AgentAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__